import {
  ConsentForm,
  ConsentFormApi,
  FormStatus,
  FormTemplateUsage,
  NppActionNeededSummary,
  NppOutcome,
  NppPendingPrompt,
  Page,
  PendingConsentSummary,
} from '@models';
import { Observable } from 'rxjs';

export abstract class ConsentFormsService {
  abstract getConsentRequests(params: {
    page: number;
    pageSize: number;
    status?: string;
    statuses?: FormStatus[];
    patientName?: string;
    orderBy?: string;
    desc?: boolean;
    usage?: FormTemplateUsage;
  }): Observable<Page<ConsentFormApi>>;

  abstract getConsentForm(id: string): Observable<ConsentFormApi>;

  abstract assignToPatient(body: {
    patientId: string;
    templateId: string;
  }): Observable<ConsentFormApi>;

  abstract sign(
    submissionId: string,
    body: {
      patientName: string;
      dateOfBirth: string;
      signature: string;
      guardianName?: string | null;
      guardianRelationship?: string | null;
    }
  ): Observable<string>;

  abstract recordNppOutcome(
    submissionId: string,
    body: {
      outcome: NppOutcome;
      patientName: string;
      dateOfBirth?: string | null;
    }
  ): Observable<NppOutcome>;

  abstract deleteSubmission(submissionId: string): Observable<unknown>;

  abstract getSubmissionsByBookingIntentId(
    id: string
  ): Observable<ConsentForm[]>;

  abstract getPdf(
    submissionId: string,
    action?: 'Download' | 'View'
  ): Observable<Blob>;

  abstract markAsOpened(submissionId: string): Observable<void>;

  abstract getSubmissionByAppointmentId(
    appointmentId: string
  ): Observable<ConsentForm[]>;

  abstract getPendingSummary(
    patientId: string
  ): Observable<PendingConsentSummary>;

  abstract sendReminder(submissionId: string): Observable<void>;

  abstract getNppActionNeeded(
    patientId: string
  ): Observable<NppActionNeededSummary>;

  abstract getMyPendingNpp(): Observable<NppPendingPrompt>;

  abstract acknowledgeNppFromPortal(
    submissionId: string,
    body: {
      patientName: string;
      dateOfBirth?: string | null;
    }
  ): Observable<NppOutcome>;
}
